import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getById(id) {
        return api.get(`/api/v1/user-approval/${id}`);
    },
    create(data) {
        return api.post(`/api/v1/user-approval`, data);
    },
    update(data) {
        return api.put(`/api/v1/user-approval`, data);
    },
}